/* Luova.fi home: rotating panels (editorial band slides, supply rail pages).
   One 6 s beat for the page, paused while the pointer or focus is inside, and no
   automatic rotation at all for reduced-motion users. Markup:
     [data-luova-rotator]            wrapper
       [data-luova-slide]            one panel each; all but the active one hidden
       [data-luova-dot="i"]          optional dot buttons
       [data-luova-prev] / [data-luova-next]
       [data-luova-page-label]       optional "2 / 3" */
(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.luovaReady) return;
    root.dataset.luovaReady = 'true';
    const slides = [...root.querySelectorAll('[data-luova-slide]')];
    if (slides.length < 2) return;
    const dots = [...root.querySelectorAll('[data-luova-dot]')];
    const label = root.querySelector('[data-luova-page-label]');
    let index = Math.max(0, slides.findIndex((s) => !s.hidden));
    let timer = null;
    let paused = false;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((s, i) => (s.hidden = i !== index));
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
        if (i === index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (label) label.textContent = `${index + 1} / ${slides.length}`;
    };

    const start = () => {
      clearInterval(timer);
      if (reduced()) return;
      timer = setInterval(() => {
        if (!paused && !document.hidden) show(index + 1);
      }, 6000);
    };

    root.addEventListener('mouseenter', () => (paused = true));
    root.addEventListener('mouseleave', () => (paused = false));
    root.addEventListener('focusin', () => (paused = true));
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) paused = false;
    });
    root.addEventListener('click', (e) => {
      const dot = e.target.closest('[data-luova-dot]');
      if (dot) {
        show(Number(dot.dataset.luovaDot));
        start();
      } else if (e.target.closest('[data-luova-prev]')) {
        show(index - 1);
        start();
      } else if (e.target.closest('[data-luova-next]')) {
        show(index + 1);
        start();
      }
    });

    show(index);
    start();
  }

  const run = () => document.querySelectorAll('[data-luova-rotator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
